import BaseComponent from './BaseComponent';

class TemplateList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;

        window.addEventListener('load', (e) => {
            const urlParams = new URLSearchParams(window.location.search);
            const asset = urlParams.get('asset');
            if (asset) {
                this.handleOverlay(asset);
                window.location.hash = 'filebank';
            }
        });

        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('.result-list__item__link')) {
                return;
            }
            this.handleOverlay(e.target.closest('.result-list__item__link').dataset.href);
        });

        this.handlePagination();
        this.handleCheckboxes(el, 'tags');
        this.handleSearch(el);
    }

    handleOverlay(url) {
        const modalSelector = document.querySelector('#filebank .modal__body');
        modalSelector.innerHTML = '';
        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject(response);
            })
            .then(function (html) {
                const div = document.createElement('div');
                div.innerHTML = html;
                modalSelector.innerHTML = div.querySelector('.file-download').outerHTML;
            })
            .catch(function (error) {
                console.warn(error);
            });
    }

    handleCheckboxes(el, selector) {
        let checkboxes = this.el.querySelectorAll(`#${selector} input`);
        let search = el.querySelector('#search');
        checkboxes.forEach((checkbox) => {
            document.body.addEventListener('change', (e) => {
                if (checkbox.value !== e.target.value) {
                    return;
                }
                let href = e.target.checked ? e.target.dataset.href : e.target.dataset.removeHref;
                if (search) {
                    href = href.replace(encodeURIComponent(':searchTerm'), search.value);
                }
                fetch(href)
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        el.querySelector('.result-list').innerHTML = div.querySelector('.result-list').innerHTML;
                        el.querySelector('#tags').innerHTML = div.querySelector('#tags').innerHTML;
                        el.querySelector('#search').setAttribute(
                            'data-href',
                            div.querySelector('#search').dataset.href
                        );
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            });
        });
    }

    handlePagination() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('#template-load-more')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            fetch(e.target.dataset.href)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    e.target.outerHTML = div.querySelector('.result-list').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }

    handleSearch(el) {
        let typingTimer;
        let doneTypingInterval = 1200;
        let search = el.querySelector('#search');
        if (!search) {
            return;
        }
        search.addEventListener('keyup', (e) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function () {
                fetch(search.dataset.href.replace(encodeURIComponent(':searchTerm'), search.value))
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        el.querySelector('.result-list').innerHTML = div.querySelector('.result-list').innerHTML;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            }, doneTypingInterval);
        });
    }
}

export default TemplateList;
